import React, { useEffect, useState } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { loginRequest, storageRequest } from "../../authConfig";
import { useAuthContext } from '../../contexts/AuthContext.js';

/**
 * Renders information about the user obtained from MS Graph 
 * @param props
 */
export const ProfileData = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  // const [accessToken, setaccessToken] = useState(null);

  const { AuthData, updateAuthData } = useAuthContext();


  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // 檢查是否有 activeAccount
        const activeAccount = instance.getActiveAccount() || accounts[0];
        if (!activeAccount) {
          console.error("No active account! User needs to log in.");
          return;
        }

        // 獲取 Microsoft Graph 的 Access Token
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: activeAccount,
        });
        const accessToken = tokenResponse.accessToken;

        // 請求 Microsoft Graph API
        const response = await axios.get("https://graph.microsoft.com/v1.0/me", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setGraphData(response.data);

        // 獲取 Access Token
        const storageTokenResponse = await instance.acquireTokenSilent({
          ...storageRequest,
          account: activeAccount,
        });
        // setaccessToken(storageTokenResponse.accessToken);
        updateAuthData("accessToken", storageTokenResponse.accessToken);

      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfile();
  }, [instance, accounts]);

  if (!graphData) {
    return <div>Loading...</div>;
  }



  return (
    <div id="profile-div">
      <p>
        <strong>First Name: </strong> {graphData.givenName}
      </p>
      <p>
        <strong>Last Name: </strong> {graphData.surname}
      </p>
      <p>
        <strong>Email: </strong> {graphData.userPrincipalName}
      </p>
      <p>
        <strong>Id: </strong> {graphData.id}
      </p>
      <p>
        {/* <strong>accessToken: </strong> {AuthData.accessToken} */}
      </p>
    </div>
  );
};